// Utility to compute the Spanish weekday from an event "day" string like "29 de Junio" or "2 de Julio 2026".
// Returns "Viernes, 29 de Junio" when parseable; otherwise returns the original string unchanged.

const MONTHS_ES = {
  enero: 0, febrero: 1, marzo: 2, abril: 3, mayo: 4, junio: 5,
  julio: 6, agosto: 7, septiembre: 8, setiembre: 8, octubre: 9, noviembre: 10, diciembre: 11,
};

const WEEKDAYS_ES = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

const stripDiacritics = (s) =>
  s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

export function formatEventDay(raw) {
  if (!raw || typeof raw !== 'string') return raw || '';
  const trimmed = raw.trim();

  // Match patterns like "29 de Junio", "2 de Julio 2026", optional weekday already prefixed.
  const match = trimmed.match(/(\d{1,2})\s+de\s+([A-Za-zÁÉÍÓÚÑáéíóúñ]+)(?:\s+(\d{4}))?/);
  if (!match) return trimmed; // legacy strings like "Jueves" or "Sábado" — leave as is

  const day = parseInt(match[1], 10);
  const monthKey = stripDiacritics(match[2]);
  const month = MONTHS_ES[monthKey];
  if (month === undefined || day < 1 || day > 31) return trimmed;

  let year = match[3] ? parseInt(match[3], 10) : null;
  if (year === null) {
    // Pick the next occurrence: this year if still upcoming, else next year
    const now = new Date();
    const thisYear = now.getFullYear();
    const candidate = new Date(thisYear, month, day);
    candidate.setHours(0, 0, 0, 0);
    const today = new Date(now);
    today.setHours(0, 0, 0, 0);
    year = candidate < today ? thisYear + 1 : thisYear;
  }

  const date = new Date(year, month, day);
  if (isNaN(date.getTime())) return trimmed;

  const weekday = WEEKDAYS_ES[date.getDay()];
  // Preserve original month spelling/casing from the input
  const rest = trimmed.replace(/^\s*[A-Za-zÁÉÍÓÚÑáéíóúñ]+\s*,\s*/, ''); // strip any existing weekday prefix
  return `${weekday}, ${rest}`;
}
